/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGcpKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGcpKmsKeyRequest = {
  /**
   * The ID of the key to get.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGcpKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpKmsKeySecurity$outboundSchema: z.ZodMiniType<
  GetGcpKmsKeySecurity$Outbound,
  GetGcpKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getGcpKmsKeySecurityToJSON(
  getGcpKmsKeySecurity: GetGcpKmsKeySecurity,
): string {
  return JSON.stringify(
    GetGcpKmsKeySecurity$outboundSchema.parse(getGcpKmsKeySecurity),
  );
}

/** @internal */
export type GetGcpKmsKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpKmsKeyRequest$outboundSchema: z.ZodMiniType<
  GetGcpKmsKeyRequest$Outbound,
  GetGcpKmsKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getGcpKmsKeyRequestToJSON(
  getGcpKmsKeyRequest: GetGcpKmsKeyRequest,
): string {
  return JSON.stringify(
    GetGcpKmsKeyRequest$outboundSchema.parse(getGcpKmsKeyRequest),
  );
}
